<template>
  <v-btn
    v-if="mobilePhone && isLpuWorking"
    color="primary"
    data-qa="appointment-button-lpu-call"
    data-google-goal="appointment_button_lpu_call"
    class="px-4"
    elevation="0"
    :block="isMobile"
    :href="`tel:${mobilePhone}`"
    @click="YaGoals.send({ name: 'appointment-call__button' })"
  >
    <div class="ui-icon-phone-none ui-kit-bg-gray-0 mr-2" />
    <span class="button--text">
      {{ t('Позвонить в клинику', { ns: language }) }}
    </span>
  </v-btn>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import I18NextVue from 'i18next'
import formatPhone from 'src/functions/formatPhone'
import YandexGoals from 'www/modules/YandexGoals'

const { t, language } = I18NextVue

const isMobile = window.MOBILE_VERSION
const YaGoals = new YandexGoals()

const props = withDefaults(defineProps<{
  lpuWorkingText?: string
  phone?: string | number,
}>(), {
  lpuWorkingText: '',
  phone: '',
})

const mobilePhone = computed(() => {
  if (!props.phone) {
    return undefined
  }

  return formatPhone({
    phone: props.phone,
    country: { iso: window.COUNTRY_DATA.iso },
    isRaw: true,
  })
})

const isLpuWorking = computed(() => (!props.lpuWorkingText))
</script>
